module.exports = __webpack_public_path__ + "static/img/BIG_BUN.9d496306.jpg";